const PACK_FIRST_FLOW_FLAG = 'pack-first-flow-v2'

const PACK_FIRST_VARIANTS = new Set<string>(['control', 'test-committed', 'test-stepper'])

function isPackFirstVariant(variant: string | boolean | undefined): boolean {
  return typeof variant === 'string' && PACK_FIRST_VARIANTS.has(variant)
}

export type CheckoutFlowExperimentVariant = 'control' | 'test-committed' | 'test-stepper'

export function useCheckoutFlowExperiment() {
  const flagVariant = useFeatureFlagVariantKey(PACK_FIRST_FLOW_FLAG)

  const isPackFirstFlow = computed(() =>
    isPackFirstVariant(flagVariant.value)
  )

  const isCommittedHourSummary = computed(() =>
    flagVariant.value === 'test-committed'
  )

  const isThreeStepStepper = computed(() =>
    flagVariant.value === 'test-stepper'
  )

  const experimentVariant = computed<CheckoutFlowExperimentVariant>(() => {
    if (flagVariant.value === 'test-committed') return 'test-committed'
    if (flagVariant.value === 'test-stepper') return 'test-stepper'
    return 'control'
  })

  return { isPackFirstFlow, isCommittedHourSummary, isThreeStepStepper, experimentVariant }
}
